export default {"src":"/_next/static/media/vault_on-light.fe915552.svg","height":72,"width":164,"blurWidth":0,"blurHeight":0};